export enum FieldType {
    INPUT = 'INPUT',
    NUMBER = 'NUMBER',
    SELECT = 'SELECT',
    AUTOCOMPLETE = 'AUTOCOMPLETE',
    DATE = 'DATE',
    TEXTAREA = 'TEXTAREA',

    FILE = 'FILE',
    FILES = 'FILES',

    COUNTRY = 'COUNTRY',
    PHONE = 'PHONE',
    EMAIL = 'EMAIL',
    WEB_SITE = 'WEB_SITE',
    ENTITY = 'ENTITY',
    MULTIPLE = 'MULTIPLE'
}

export type SelectFieldListOption = {
    label: string,
    value: string
};

export type DefaultFormFieldMetadata = {
    hint?: string,
    prefix?: string,
    suffix?: string,
    notes?: Array<string>,
    canBeMirroredFromField?: string, // formValue.obj.subj.field
};

export type FormControlConfig = {
    key: string,
    label?: string,
};

type GenericFormField<FT extends FieldType, Metadata extends DefaultFormFieldMetadata = DefaultFormFieldMetadata> = FormControlConfig & {
    fieldType: FT,
    required?: boolean | null,
    disabled?: boolean | null,
    defaultValueSource?: string | null,  // Path in Global user context to auto preload data (USER_CONTEXT.company.registrationNumber)
    defaultValue: any | null,
    metadata?: Metadata | null
};

export type InputField = GenericFormField<FieldType.INPUT>;

export type NumberField = GenericFormField<FieldType.NUMBER>;

export type SelectField = GenericFormField<FieldType.SELECT> & {
    optionSource: string,
    options: Array<SelectFieldListOption>
};

export type AutocompleteField = GenericFormField<FieldType.AUTOCOMPLETE> & {
    optionSource: string,
    options: Array<SelectFieldListOption>,
};

export type TextareaField = GenericFormField<FieldType.TEXTAREA>;
export type PhoneField = GenericFormField<FieldType.PHONE>;
export type EmailField = GenericFormField<FieldType.EMAIL>;
export type WebSiteField = GenericFormField<FieldType.WEB_SITE>;
export type DateField = GenericFormField<FieldType.DATE>;
export type FileField = GenericFormField<FieldType.FILE>;
export type FilesField = GenericFormField<FieldType.FILES>;
export type CountryField = GenericFormField<FieldType.COUNTRY>;

export type Entity = GenericFormField<FieldType.ENTITY> & {
    children: Array<FormFieldType>
};

export type Multiple = GenericFormField<FieldType.MULTIPLE> & {
    min: number,
    max?: number,
    subject: FormFieldType
};

export type FormFieldType = InputField
    | NumberField
    | EmailField
    | WebSiteField
    | SelectField
    | AutocompleteField
    | TextareaField
    | PhoneField
    | DateField
    | FileField
    | FilesField
    | CountryField
    | Entity
    | Multiple;

export type BusinessFormSection = FormControlConfig & {
    children: Array<FormFieldType>,
    metadata: DefaultFormFieldMetadata
};

export type BusinessForm = {
    key: string,
    description?: string,
    children: Array<FormFieldType | BusinessFormSection>
};

export type MirrorFieldData = {
    path: string,
    field: FormFieldType | null
};

export type MirrorFieldsOption = {
    name: string,
    label: string,
    value: any,
};

export type UpdateIndividualProfileByAdminType = {
    userId: number
    email: string;
    firstName: string;
    lastName: string;
    country: string;
    mobileNumber: string;
    birthDate: string | Date;
    address: string
}

export type UpdateBusinessProfileByAdminType = UpdateIndividualProfileByAdminType & {
    companyName: string;
    companyAddress: string;
    companyRegNumber: string;
}

export function isUpdateBusinessProfileByAdminType($: Omit<UpdateProfileByAdminType, 'userId'> | UpdateProfileByAdminType ): $ is UpdateBusinessProfileByAdminType {
    return $.hasOwnProperty('companyName');
}

export type UpdateProfileByAdminType = UpdateBusinessProfileByAdminType | UpdateIndividualProfileByAdminType;
